import { Apis } from "libs/apis";

// Hook for bulk ingredient details operations
export const useBulkIngredientDetails = () => {
    const downloadSampleCsvFile = async (setCsvFileLink: (link: string) => void, start?: number, end?: number) => {
        try {
            const response = await Apis.getBulkIngredientDetailsSampleCsvFile(start, end);

            // Detect file type from Content-Type header or blob content
            const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
            let blobType = 'text/csv';
            let fileName = 'sample_ingredients.csv';

            // response.data is already a Blob when responseType: 'blob' is set
            let arrayBuffer: ArrayBuffer;
            
            // Check if it's an XLSX file (ZIP-based Office format) from Content-Type
            if (contentType.includes('spreadsheetml') || 
                contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                contentType.includes('application/vnd.ms-excel')) {
                blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileName = 'sample_ingredients.xlsx';
                arrayBuffer = await response.data.arrayBuffer();
            } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
                blobType = 'text/csv';
                fileName = 'sample_ingredients.csv';
                arrayBuffer = await response.data.arrayBuffer();
            } else {
                // Try to detect from blob content (check for ZIP signature)
                arrayBuffer = await response.data.arrayBuffer();
                const uint8Array = new Uint8Array(arrayBuffer);
                // Check for ZIP signature (PK) at the start
                if (uint8Array.length >= 2 && uint8Array[0] === 0x50 && uint8Array[1] === 0x4B) {
                    // It's a ZIP file, likely XLSX
                    blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    fileName = 'sample_ingredients.xlsx';
                } else {
                    // Default to CSV
                    blobType = 'text/csv';
                    fileName = 'sample_ingredients.csv';
                }
            }

            // Create blob with detected type using the arrayBuffer
            const blob = new Blob([arrayBuffer], { type: blobType });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setCsvFileLink(url);
        } catch (error) {
            console.error('Error downloading sample CSV:', error);
            throw error;
        }
    };

    const uploadBulkIngredientDetails = async (formData: FormData) => {
        try {
            const response = await Apis.uploadBulkIngredientDetails(formData);
            return response;
        } catch (error) {
            console.error('Error uploading bulk ingredient details:', error);
            throw error;
        }
    }

    return {
        downloadSampleCsvFile,
        uploadBulkIngredientDetails
    };
};